import { Controller } from "@hotwired/stimulus";

// A checkbox that, once unticked, empties the fields in its block (ID-194).
// conditional-fields only hides the block, so the old value would come back
// the next time the box is ticked. The server clears it too; this keeps the
// form honest in the browser.
export default class extends Controller {
  change(event) {
    if (event.target.checked) return;

    this.element
      .querySelectorAll("input[type='text'], select")
      .forEach((field) => {
        if (field.tomselect) field.tomselect.clear();
        else field.value = "";
      });
  }
}
